$(function() {

    // @ variables -----------------------
    var $nav = $(".js-hpt__nav");

    if ($nav.length === 0) {
        return;
    }

    var $window = $(window);
    var pos = {
        window: 0,
        nav: $nav.position().top,
        dist: 0,
        min_width: 1024,
        page_height: document.body.offsetHeight
    };
    var debounce_delay = 50;

    // @ functions -----------------------
    $(document).delegate(".is-clickable", "click", function() {
        window.location = $(this).find("a").attr("href");
    });

    function debounce(method, delay) {
        clearTimeout(method._tId);
        method._tId = setTimeout(function() {
            method();
        }, delay);
    }

    function handleScroll() {
        if ($window.width() < pos.min_width) {
            return;
        }

        pos.window = $window.scrollTop();
        pos.dist = pos.window - pos.nav;

        if (pos.dist > 0) {
            var top = pos.dist + 10;

            $nav.css({ top: top + 'px' });
        } else {
            $nav.css({ top: 0 });
        }
    }

    function handleResize() {
        if ($window.width() < pos.min_width) {
            $nav.css({ top: 0 });
        }

        pos.nav = $nav.position().top;
    }

    // @ event listeners -----------------------
    $window.scroll(function() {
        debounce(handleScroll, debounce_delay);
    });

    $window.resize(function() {
        debounce(handleResize, debounce_delay);
    });

    console.clear();
});
